import styled from "styled-components"

export const DateContainer = styled.span`
  font-size: 13px;
  line-height: 16px;
  color: #7b828a;
`

export const SubTitle = styled.div`
  margin-top: -8px;
  margin-bottom: 24px;
`
